export enum SurveyRuleCommonValidationError {
  EMPTY_VALUE = "EMPTY_VALUE",
}

export const getSurveyRuleValidationErrorValues = <
  ValidationErrorEnum extends string,
>(
  validationErrorEnum: ValidationErrorEnum[],
): (ValidationErrorEnum | SurveyRuleCommonValidationError)[] => [
  ...validationErrorEnum,
  ...Object.values(SurveyRuleCommonValidationError),
];
